import keyBy from 'lodash.keyby';
import {
  FETCH_NFC_TAGS_REQUEST,
  FETCH_NFC_TAGS_SUCCESS,
  FETCH_NFC_TAGS_FAILURE,
  NFC_TAGS_CHANGE_PAGE,
  SAVE_NFC_TAG_REQUEST,
  SAVE_NFC_TAG_SUCCESS,
  SAVE_NFC_TAG_FAILURE,
  REPLACE_NFC_TAG_REQUEST,
  REPLACE_NFC_TAG_SUCCESS,
  REPLACE_NFC_TAG_FAILURE
} from './types';

const initialstate = {
  pageSize: 20,
  currentPage: 0,
  fetchNfcTagsLoaded: true,
  fetchNfcTagsError: null,
  allById: {},
  allIds: [],
  saveNfcTagLoaded: true,
  saveMessageError: false
};

export default function nfc(state = initialstate, action = {}) {
  switch (action.type) {
    case FETCH_NFC_TAGS_REQUEST:
      return {
        ...state,
        fetchNfcTagsLoaded: false,
        fetchNfcTagsError: null
      };
    case FETCH_NFC_TAGS_SUCCESS:
      return {
        ...state,
        fetchNfcTagsLoaded: true,
        fetchNfcTagsError: null,
        allById: keyBy(action.data, (tag) => tag.id),
        allIds: action.data.map((tag) => tag.id)
      };
    case FETCH_NFC_TAGS_FAILURE:
      return {
        ...state,
        fetchNfcTagsLoaded: true,
        fetchNfcTagsError: action.errors
      };
    case NFC_TAGS_CHANGE_PAGE:
      return {
        ...state,
        currentPage: action.data.page,
      };
    case SAVE_NFC_TAG_REQUEST:
      return {
        ...state,
        saveNfcTagLoaded: false,
        saveMessageError: null
      };
    case SAVE_NFC_TAG_SUCCESS:
      return {
        ...state,
        saveNfcTagLoaded: true,
        saveMessageError: null
      };
    case SAVE_NFC_TAG_FAILURE:
      return {
        ...state,
        saveNfcTagLoaded: true,
        saveMessageError: action.error
      };
    case REPLACE_NFC_TAG_REQUEST:
      return {
        ...state,
        saveNfcTagLoaded: false,
        saveMessageError: null
      };
    case REPLACE_NFC_TAG_SUCCESS:
      return {
        ...state,
        saveNfcTagLoaded: true,
        saveMessageError: null
      };
    case REPLACE_NFC_TAG_FAILURE:
      return {
        ...state,
        saveNfcTagLoaded: true,
        saveMessageError: action.error
      };
    default:
      return state;
  }
}
